export default __webpack_public_path__ + "static/park-pedregal-amenidades-05-lounge-9d62eab77e5ff5a9eea14e6d1c109b3e.jpg";